import type { AllPermissions } from '../../Types/Api/Permission'
import { api } from './API'
import { requireAuth } from './Auth'

export const findAllPermission = () => {
  return requireAuth<AllPermissions>(api.get(`permissions`))
}
